import { TGetContext } from '../types';

export const AMPLITUDE_USER_PROPERTIES = {
  DECISION_TYPE: 'Decision type',
  REQUESTED_AMOUNT: 'Requested amount',
  SUGGESTED_AMOUNT: 'Suggested amount',
  REQUESTED_PRODUCT: 'Requested product',
  SUGGESTED_PRODUCT: 'Suggested product',
};

export const getAmplitudeDefaultEventProperties = () => {
  const pathname = window.location.pathname;
  const isDirectCustomer = pathname && pathname.includes('/apply');

  return {
    category: isDirectCustomer ? 'Signup' : 'Partner signup',
    pageName: document.title || '',
    url: pathname || '',
  };
};

export const getAmplitudeSite = () => {
  const hostname = window.location.hostname;

  if (hostname.endsWith('.de')) {
    return 'DE';
  }

  return 'UK';
};

export const getAmplitudeDomainCountry = () => {
  const hostname = window.location.hostname;

  // For testing
  if (!hostname) return '';

  if (hostname.endsWith('.de')) {
    return 'DE';
  }
  if (hostname.endsWith('.co.uk')) {
    return 'UK';
  }
  return `Other - ${hostname}`;
};

export const getAmplitudeDeviceCategory = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'Tablet';
  } else if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua,
    )
  ) {
    return 'Mobile';
  } else {
    return 'Desktop';
  }
};

export const getAmplitudeSplitTestsFromContext = (
  contextData: TGetContext['data'],
) => {
  if (!contextData?.user_split_tests) {
    return [];
  }

  return contextData.user_split_tests.map((splitTest) => {
    let splitTestName = '';
    for (const key in splitTest) {
      if (Object.prototype.hasOwnProperty.call(splitTest, key)) {
        // @ts-expect-error context schema nonsense
        splitTestName = `${key}=${splitTest[key]}`;
      }
    }

    return splitTestName;
  });
};
